import type {Elevations, ThemeModes} from '../types';

const darkElevations: Elevations = {
  level1: '0px 1px 0px rgba(0, 0, 0, 0.1)',
  level2: '0px 2px 1px rgba(0, 0, 0, 0.1), 0px 0px 1px rgba(0, 0, 0, 0.25)',
  level3: '0px 0px 2px rgba(0, 0, 0, 0.2), 0px 4px 10px rgba(0, 0, 0, 0.1)',
  level4: '0px 0px 2px rgba(0, 0, 0, 0.1), 0px 8px 20px rgba(0, 0, 0, 0.15)',
  popup: '0px 24px 58px 0px rgba(0, 0, 0, 0.28), 0px 0px 8px 0px rgba(0, 0, 0, 0.04)',
  dropdown: '0px 16px 48px 0px rgba(0, 0, 0, 0.08), 0px 0px 8px 0px rgba(0, 0, 0, 0.04)',
  tooltip: '0px 0px 10px 0px rgba(0, 0, 0, 0.08), 0px 0px 8px 0px rgba(0, 0, 0, 0.04)',
  buttonElevation: '0px 0px 9px 0px rgba(0, 0, 0, 0.06),  0px 0px 3px 0px rgba(0, 0, 0, 0.06)',
  cardElevation: '0px 3px 16px 0px rgba(0, 0, 0, 0.06), 0px 1px 8px 0px rgba(0, 0, 0, 0.04)',
  flyout: '0px 8px 20px 0px rgba(0, 0, 0, 0.08), 0px 2px 6px 0px rgba(0, 0, 0, 0.02)',
};

const lightElevations: Elevations = {
  level1: '0px 1px 0px rgba(0, 0, 0, 0.1)',
  level2: '0px 2px 1px rgba(0, 0, 0, 0.1), 0px 0px 1px rgba(0, 0, 0, 0.25)',
  level3: '0px 0px 2px rgba(0, 0, 0, 0.2), 0px 4px 10px rgba(0, 0, 0, 0.1)',
  level4: '0px 0px 2px rgba(0, 0, 0, 0.1), 0px 8px 20px rgba(0, 0, 0, 0.15)',
  popup: '0px 24px 58px 0px rgba(0, 0, 0, 0.28), 0px 0px 8px 0px rgba(0, 0, 0, 0.04)',
  dropdown: '0px 16px 48px 0px rgba(0, 0, 0, 0.08), 0px 0px 8px 0px rgba(0, 0, 0, 0.04)',
  tooltip: '0px 0px 10px 0px rgba(0, 0, 0, 0.08), 0px 0px 8px 0px rgba(0, 0, 0, 0.04)',
  buttonElevation: '0px 0px 9px 0px rgba(0, 0, 0, 0.06),  0px 0px 3px 0px rgba(0, 0, 0, 0.06)',
  cardElevation: '0px 3px 16px 0px rgba(0, 0, 0, 0.06), 0px 1px 8px 0px rgba(0, 0, 0, 0.04)',
  flyout: '0px 8px 20px 0px rgba(0, 0, 0, 0.08), 0px 2px 6px 0px rgba(0, 0, 0, 0.02)',
};

export const themeModeToElevations: Record<ThemeModes, Elevations> = {
  dark: darkElevations,
  light: lightElevations,
};
